module.exports = __webpack_public_path__ + "img/book_of_the_dead.589f14f3.png";